export const CANDIDATE_PROFILE_STORAGE_KEY = "wibil_candidate_profile";

export function candidateProfilePath(c) {
  const id = c?.id ?? c?.employeeId ?? c?.employee_id ?? c?.name ?? c?.candidate_name ?? "candidate";
  return `/recruiter/candidate-profile/${encodeURIComponent(String(id))}`;
}

export function persistCandidateForProfile(c) {
  try {
    const raw = JSON.stringify(c || null);
    sessionStorage.setItem(CANDIDATE_PROFILE_STORAGE_KEY, raw);
    localStorage.setItem(CANDIDATE_PROFILE_STORAGE_KEY, raw);
  } catch (e) {
    /* ignore quota / private mode */
  }
}

export function readPersistedCandidate() {
  try {
    const raw = sessionStorage.getItem(CANDIDATE_PROFILE_STORAGE_KEY)
      || localStorage.getItem(CANDIDATE_PROFILE_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function clearPersistedCandidate() {
  try {
    sessionStorage.removeItem(CANDIDATE_PROFILE_STORAGE_KEY);
    localStorage.removeItem(CANDIDATE_PROFILE_STORAGE_KEY);
  } catch (e) {
    /* ignore */
  }
}
